import { getMutationsForScope } from '../utils';

const mutation = getMutationsForScope('windowMedia');

const mediaState = {
  mediaXlarge: false,
  mediaLarge: false,
  mediaMedium: false,
  mediaSmall: false,
  icbWidth: 0,
  icbHeight: 0,
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight, // TODO: parent window height
  deviceType: null,
  deviceOs: null,
  browser: null,
  scrollTop: 0, // TODO: parent window scroll toop
};

const moduleGetters = {
  /**
   * If this is a mobile device
   *
   * NOT A MEDIA QUERY, NOT FOR LAYOUT
   *
   * @param {*} state
   * @returns {Boolean}
   */
  isMobile(state) {
    return state.deviceType === 'mobile';
  },

  /**
   * If this is a tablet
   *
   * NOT A MEDIA QUERY, NOT FOR LAYOUT
   *
   * @param {*} state
   * @returns {Boolean}
   */
  isTablet(state) {
    return state.deviceType === 'tablet';
  },

  /**
   * If this is a device primarily used via touch screen
   *
   * @param {*} state
   * @param {*} getters
   * @returns {Boolean}
   */
  isTouchCentric(state, getters) {
    return getters.isTablet || getters.isMobile;
  },

  /**
   * If this is an iOS device
   *
   * @param {*} state
   * @returns {Boolean}
   */
  isIos(state) {
    return state.deviceOs === 'iOS';
  },

  /**
   * If this is IE
   *
   * @param {*} state
   * @returns {Boolean}
   */
  isIE(state) {
    return state.browser === 'IE';
  },

  /**
   * Initial containing block dimension, if set. Otherwise window dimension
   *
   * @returns {Number} dimension in pixels
   */
  viewportWidth(state) {
    return state.icbWidth ? state.icbWidth : state.windowWidth;
  },

  /**
   * Initial containing block dimension, if set. Otherwise window dimension
   *
   * @returns {Number} dimension in pixels
   */
  viewportHeight(state) {
    return state.icbHeight ? state.icbHeight : state.windowHeight;
  }
};

const mediaMutations = {
  /**
   * Set device type using UA Parser JS
   *
   * this will be `undefined` for devices that aren't known or desktops
   *
   * @param {*} state
   * @param {*} payload { device }
   */
  [mutation.WINDOW_MEDIA_SET_DEVICE_TYPE](state, { device } = {}) {
    state.deviceType = device.type;
  },

  /**
   * Set device OS using UA Parser JS
   *
   * @param {*} state
   * @param {*} [{ os }={}]
   */
  [mutation.WINDOW_MEDIA_SET_OS](state, { os } = {}) {
    state.deviceOs = os.name;
  },


  /**
   * Set browser using UA Parser JS
   *
   * @param {*} state
   * @param {*} [{ browser }={}]
   */
  [mutation.WINDOW_MEDIA_SET_BROWSER](state, { browser } = {}) {
    state.browser = browser.name;
  },


  /**
   * Set the size of the user's view
   *
   * @param {*} state
   * @param {*} {
   *     innerWidth,
   *     innerHeight,
   *     icbWidth,
   *     icbHeight,
   *   }
   */
  [mutation.WINDOW_MEDIA_SET_SIZE](state, {
    innerWidth,
    innerHeight,
    icbWidth,
    icbHeight,
  }) {
    state.windowWidth = innerWidth;
    state.windowHeight = innerHeight;
    state.icbWidth = icbWidth;
    state.icbHeight = icbHeight;
  },

  /**
   * Set the scrollTop value
   *
   * @param {*} state
   * @param {*} { scrollTop }
   */
  [mutation.WINDOW_MEDIA_SET_SCROLL_TOP](state, { scrollTop }) {
    state.scrollTop = scrollTop;
  },

  [mutation.WINDOW_MEDIA_SET_MEDIA_XLARGE](state, { matches }) {
    state.mediaXlarge = matches;
  },

  [mutation.WINDOW_MEDIA_SET_MEDIA_LARGE](state, { matches }) {
    state.mediaLarge = matches;
  },

  [mutation.WINDOW_MEDIA_SET_MEDIA_MEDIUM](state, { matches }) {
    state.mediaMedium = matches;
  },

  [mutation.WINDOW_MEDIA_SET_MEDIA_SMALL](state, { matches }) {
    state.mediaSmall = matches;
  },
};

export default {
  namespaced: true,
  state: mediaState,
  mutations: mediaMutations,
  getters: moduleGetters,
};
